export const propertyTypes = [
  { value: 'Appartement', label: 'Appartement' },
  { value: 'Maison', label: 'Maison' },
  { value: 'Studio', label: 'Studio' },
  { value: 'Loft', label: 'Loft' },
  { value: 'Terrain', label: 'Terrain' }
];

export const heatingTypes = [
  { value: 'unknown', label: 'Choisir la nature de votre chauffage' },
  { value: 'electrique', label: 'Électrique' },
  { value: 'gaz', label: 'Gaz' },
  { value: 'fioul', label: 'Fioul' },
  { value: 'bois', label: 'Bois' },
  { value: 'pompe_chaleur', label: 'Pompe à chaleur' },
  { value: 'je_ne_sais_pas', label: 'Je ne sais pas' }
];

export const heatingSystemTypes = [
  { value: 'unknown', label: 'Choisir le type de votre chauffage' },
  { value: 'individuel', label: 'Individuel' },
  { value: 'collectif', label: 'Collectif' },
  { value: 'je_ne_sais_pas', label: 'Je ne sais pas' }
];

export const expositionOptions = [
  { value: 'unknown', label: 'Choisir votre exposition' },
  { value: 'nord', label: 'Nord' },
  { value: 'sud', label: 'Sud' },
  { value: 'est', label: 'Est' },
  { value: 'ouest', label: 'Ouest' },
  { value: 'nord-est', label: 'Nord-Est' },
  { value: 'nord-ouest', label: 'Nord-Ouest' },
  { value: 'sud-est', label: 'Sud-Est' },
  { value: 'sud-ouest', label: 'Sud-Ouest' },
  { value: 'je_ne_sais_pas', label: 'Je ne sais pas' }
];

export const conditionLabels = {
  0: 'Mauvais',
  50: 'Bon',
  100: 'Excellent'
};

export const roomOptions = Array.from({ length: 10 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1} ${i === 0 ? 'pièce' : 'pièces'}`
}));

export const floorOptions = Array.from({ length: 11 }, (_, i) => ({
  value: i,
  label: i === 0 ? 'Rez-de-chaussée' : `${i}${i === 1 ? 'er' : 'ème'} étage`
}));

export const yearOptions = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, i) => ({
    value: 1900 + i,
    label: `${1900 + i}`
  })
);

export const propertyOwnershipTypes = [
  { value: 'owner', label: 'Je suis le propriétaire du bien' },
  { value: 'tenant', label: 'Je suis locataire' },
  { value: 'professional', label: 'Je suis un professionnel de l\'immobilier' },
  { value: 'other', label: 'Autre' }
];

export const kitchenTypes = [
  { value: 'americaine', label: 'Cuisine américaine' },
  { value: 'equipee', label: 'Cuisine équipée' },
  { value: 'separee', label: 'Cuisine séparée' },
  { value: 'coin_cuisine', label: 'Coin cuisine' }
];

export const windowTypes = [
  { value: 'simple', label: 'Simple vitrage' },
  { value: 'double', label: 'Double vitrage' },
  { value: 'triple', label: 'Triple vitrage' }
];

export const parkingTypes = [
  { value: 'box', label: 'Box fermé' },
  { value: 'garage', label: 'Garage individuel' },
  { value: 'parking', label: 'Place de parking' },
  { value: 'sous_sol', label: 'Parking en sous-sol' }
];

export const securityFeatures = [
  { value: 'digicode', label: 'Digicode' },
  { value: 'interphone', label: 'Interphone' },
  { value: 'gardien', label: 'Gardien' },
  { value: 'camera', label: 'Vidéosurveillance' },
  { value: 'alarme', label: 'Système d\'alarme' }
];

export const loadingSteps = [
  'Enregistrement de vos données',
  'Envois des données à notre serveur',
  'Analyse des données de votre bien',
  'Comparaison de votre bien avec d\'autres bien de votre quartier',
  'Estimation de votre bien',
  'Estimation effectuée',
  'Estimation envoyée par mail',
  'Merci'
];

export const stepTitles = [
  'Type de bien',
  'Caractéristiques du bien',
  'Caractéristiques de l\'immeuble',
  'État de l\'appartement',
  'État de l\'immeuble',
  'Affiner votre estimation',
  'Vos coordonnées'
];